'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = publish;

var _xodProject = require('xod-project');

var XP = _interopRequireWildcard(_xodProject);

var _utils = require('./utils');

var _libUri = require('./lib-uri');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

const packLibVersion = project => ({
  libname: XP.getProjectName(project),
  version: {
    description: XP.getProjectDescription(project),
    folder: { 'xodball.json': XP.toXodball(project) },
    semver: `v${XP.getProjectVersion(project)}`
  }
});

function publish(swaggerUrl, grant, project) {
  return (0, _utils.getSwaggerClient)(swaggerUrl).then(swagger => {
    const { Library, Organization, User, Version } = swagger.apis;

    // eslint-disable-next-line no-param-reassign
    swagger.authorizations = {
      bearer_token: `Bearer ${grant.accessToken}`
    };
    const { username } = grant.user;
    const orgname = username;

    const { libname, version } = packLibVersion(project);
    const libUri = (0, _libUri.createLibUri)(orgname, libname, version.semver);

    return Organization.getOrg({ orgname }).catch(err => {
      if (err.status !== 404) throw (0, _utils.swaggerError)(err);
      return User.putUserOrg({ org: {}, orgname, username }).catch(err2 => {
        if (err2.status === 403) {
          throw new Error(`user "${username}" is not registered.`);
        }
        if (err2.status === 409) {
          throw new Error(`orgname "${orgname}" is already taken.`);
        }
        throw (0, _utils.swaggerError)(err2);
      });
    }).then(() => Library.getOrgLib({ libname, orgname }).catch(err => {
      if (err.status !== 404) throw (0, _utils.swaggerError)(err);
      return Library.putOrgLib({ lib: {}, libname, orgname }).catch(err2 => {
        if (err2.status === 403) {
          throw new Error(`user "${username}" can't access ${(0, _libUri.toStringWithoutTag)(libUri)}.`);
        }
        throw (0, _utils.swaggerError)(err2);
      });
    })).then(() => Version.postLibVersion({ libname, orgname, version }).catch(err => {
      if (err.status === 409) {
        throw new Error(`version "${(0, _libUri.toString)(libUri)}" already exists.`);
      }
      throw (0, _utils.swaggerError)(err);
    }));
  });
}


//////////////////
// WEBPACK FOOTER
// ../xod-pm/dist/publish.js
// module id = 1463
// module chunks = 0